var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2677 19.8919C16.6942 19.246 17.1667 18.5552 17.6362 17.9543C22.4986 11.2169 28.257 9.23134 31.4625 8.72542C29.5755 9.23232 28.0177 10.1062 26.7443 11.2619C23.1574 13.9882 19.0979 19.8929 14.2405 32.5859C14.1434 32.8619 14.0052 33.0957 13.816 33.2787V33.3228C12.7268 34.6145 10.6065 28.4759 10.0358 26.8632L4.84408 12.6456C3.80593 9.73727 3.33441 8.81643 2.34932 8.58451C1.82474 8.44653 1.16701 8.39956 0.695489 8.39956C0.360118 8.35357 0.0788066 8.21755 0.0317545 8.03064C-0.106398 7.70967 0.222966 7.66368 0.695489 7.66368C2.48647 7.70967 4.18635 7.89168 4.51472 7.89168C5.17645 7.89168 6.77922 7.7997 9.05074 7.84765C9.51625 7.89168 9.85063 7.93767 9.94373 8.21852C10.0358 8.44849 9.89668 8.58549 9.4712 8.58549C8.90758 8.53754 8.24385 8.58549 7.72527 8.7724C7.11259 9.0004 6.96944 9.78619 7.82338 12.3706L11.1701 22.8932C13.817 13.4294 24.1485 1.10628 40 9.04444C27.7364 3.73765 21.3163 11.4918 16.2677 19.8919Z",
    fill: "#BF4036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVern);
export default __webpack_public_path__ + "static/media/vern.0e9dc83fc6b4784c207d366bdc5edf56.svg";
export { ForwardRef as ReactComponent };